import { Controller } from '@hotwired/stimulus';
import { method } from './helpers';

interface FormResetOptions {
  element?: HTMLFormElement;
}

const useResetForm = (controller: Controller, options: FormResetOptions = {}) => {
  const targetElement = options.element || controller.element;

  const reset = (event: Event) => {
    method(controller, 'resetForm').call(controller, event);
  };

  const controllerDisconnect = () => controller.disconnect.bind(this);

  const observe = () => targetElement.addEventListener('reset', reset);
  const unobserve = () => targetElement.removeEventListener('reset', reset);

  Object.assign(controller, {
    disconnect() {
      unobserve();
      controllerDisconnect();
    },
  });

  observe();

  return [observe, unobserve] as const;
};

export default useResetForm;
